import React, { useEffect, useState, useContext } from "react";
import { SiteContext } from "../contexts/SiteContext";
import {
	makeStyles,
	SwipeableDrawer,
	IconButton,
	List,
	useTheme,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import MenuDrawerItem from "./MenuDrawerItem";
const useStyles = makeStyles((theme) => ({
	list: {
		width: 250,
	},
}));

export default function MenuDrawer() {
	const theme = useTheme();
	const classes = useStyles();
	const [loading, setLoading] = useState(true);
	const { selectedSite } = useContext(SiteContext);
	const [menu, setMenu] = useState();
	const [drawerState, setDrawerState] = React.useState({
		top: false,
		left: false,
		bottom: false,
		right: false,
	});

	useEffect(() => {
		const fetchMenu = async () => {
			let res = await fetch(
				`${process.env.REACT_APP_API_URL}/menus?site=${selectedSite._id}`,
				{ credentials: "include" }
			);
			res = await res.json();
			if (res.success) {
				if (res.data.length < 1) {
					alert(
						`No menu found for this site. Please contact webmaster@lva.virginia.gov`
					);
				}
				setMenu(res.data[0]);
				setLoading(false);
			} else {
				console.log(res.error);
			}
		};
		fetchMenu();
	}, [selectedSite]);

	const toggleDrawer = (side, open) => (event) => {
		if (
			event &&
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}

		setDrawerState({ ...drawerState, [side]: open });
	};

	if (loading || !selectedSite || !menu) {
		return "Loading...";
	}

	const sideList = (side) => (
		<div
			className={classes.list}
			role="presentation"
			//onClick={toggleDrawer(side, false)}
			onKeyDown={toggleDrawer(side, false)}
		>
			<List>
				{menu.links.map((mainLink, i) => {
					return <MenuDrawerItem key={i} mainLink={mainLink} />;
				})}
			</List>
		</div>
	);

	return (
		<div>
			<IconButton
				style={{ color: theme.palette.primary.contrastText }}
				onClick={toggleDrawer("left", true)}
			>
				<MenuIcon />
			</IconButton>
			<SwipeableDrawer
				anchor="left"
				open={drawerState.left}
				onClose={toggleDrawer("left", false)}
				onOpen={toggleDrawer("left", true)}
			>
				{sideList("left")}
			</SwipeableDrawer>
		</div>
	);
}
